import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { SpecialCommon } from './special.common';
import { Injector } from '@angular/core';
@Component({
	selector: 'page-special',
  	templateUrl: 'special.html'
})

export class SpecialPage extends PageBase {
	public special:  string;
	public mySlideOptions = {
		initialSlide: 0,
		loop: true,
		pager: false
	};

	constructor(
		public injector: Injector,
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: SpecialCommon
	) {

		super(settings, events, nav, userData);
	}

	ngAfterViewInit() {
		this.common.commonMethod();
		this.special =  "pageView";
	}

	ionViewDidEnter() {
		
	}
}



// WEBPACK FOOTER //
// ./src/modules/special/pages/special/special.ts